import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryTermWordText({word, search, highlight}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(word))
        return null
    return (
        <div className="font-bold text-[14px] min-w-0"
             dangerouslySetInnerHTML={{ __html: highlight(word, search) }} />
    );
}